import { api } from "@/api"
import { useQuery } from "@tanstack/vue-query"

type RetrieveGratuityOptionsResponse = {
  gratuityOptions: [number, number, number, number]
}

export const retrieveGratuityOptions = async () => {
  const { body } =
    await api.get<RetrieveGratuityOptionsResponse>(
      "/gratuity-options/"
    )
  return body.gratuityOptions
}

export const useGratuityOptions = () =>
  useQuery({
    queryKey: [BASE_GRATUTIY_OPTIONS_QUERY_KEY],
    queryFn: retrieveGratuityOptions,
    staleTime: 60 * 60 * 1000,
  })
